/* global axios */
import ApiClient from './ApiClient';

// DEBT customization — as duas superfícies por CONVERSA do namespace debt que
// não são do Kanban: a correlação com o DEBTHUB (confirmada por humano) e o
// resumo com IA. As duas são escopadas pelo display_id da conversa (json.id de
// _conversation.json.jbuilder), a mesma convenção dos endpoints do Kanban.
//
// DESEMPENHO — `debthubLink` resolve SINCRONAMENTE contra outro sistema
// (Debt::DebthubLinkResolver). Ela só pode ser chamada na abertura de UMA
// conversa; no caminho de render do board, os 42.594 cards da conta 1 virariam
// 42.594 chamadas HTTP externas. O teste que fixa essa restrição está em
// KanbanBoardIndex.spec.js ("never resolves the DEBTHUB link while rendering
// the board").
class DebtConversationApi extends ApiClient {
  constructor() {
    super('debt/conversations', { accountScoped: true, apiVersion: 'v2' });
  }

  debthubLink(conversationDisplayId) {
    return axios.get(`${this.url}/${conversationDisplayId}/debthub_link`);
  }

  confirmDebthubLink(conversationDisplayId, pessoaId) {
    return axios.post(
      `${this.url}/${conversationDisplayId}/debthub_link/confirm`,
      {
        pessoa_id: pessoaId,
      }
    );
  }

  // Rejeição é POR CANDIDATO ("este contato não é a pessoa X"), nunca "este
  // contato não tem vínculo": por isso o pessoa_id é obrigatório aqui também.
  rejectDebthubLink(conversationDisplayId, pessoaId) {
    return axios.post(
      `${this.url}/${conversationDisplayId}/debthub_link/reject`,
      {
        pessoa_id: pessoaId,
      }
    );
  }

  undoDebthubLink(conversationDisplayId) {
    return axios.post(`${this.url}/${conversationDisplayId}/debthub_link/undo`);
  }

  // Aba Pipedrive AO VIVO da expansão lateral — SÓ chamado quando o agente abre aquela aba
  // (nunca junto de `debthubLink`), com `deal_id` OU `person_id`, nunca os dois. O
  // controller valida que o id pedido é um candidato real desta conversa (ver
  // Api::V2::Accounts::Debt::DebthubLinksController#pipedrive) e cacheia/limita a chamada
  // do lado do servidor — este cliente não soma cache próprio.
  // Exatamente um dos três. `pessoaId` é a pessoa do DEBTHUB e existe para a
  // conversa cujo cadastro não carrega id nenhum do Pipedrive — o servidor
  // resolve pelo documento daquele candidato, que nunca trafega daqui.
  pipedriveLookup(conversationDisplayId, { dealId, personId, pessoaId }) {
    let params = { pessoa_id: pessoaId };
    if (dealId) params = { deal_id: dealId };
    else if (personId) params = { person_id: personId };
    return axios.get(
      `${this.url}/${conversationDisplayId}/debthub_link/pipedrive`,
      { params }
    );
  }

  // POST com corpo vazio de propósito: a chamada gasta token de LLM, e um GET
  // convidaria prefetch do navegador e retry automático sobre uma operação
  // cobrada (ver conversation_summaries_controller.rb).
  summary(conversationDisplayId) {
    return axios.post(`${this.url}/${conversationDisplayId}/summary`);
  }

  // GET LÊ o resumo guardado e não gera nada — por isso é seguro, ao contrário
  // do POST acima. É o que faz o painel abrir pronto quando alguém já resumiu
  // aquela conversa, sem cobrar o LLM de novo.
  storedSummary(conversationDisplayId) {
    return axios.get(`${this.url}/${conversationDisplayId}/summary`);
  }
}

export default new DebtConversationApi();
